import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
    HttpErrorResponse,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError, retry } from "rxjs/operators";
import { NotificacionesService } from "../rest/notificaciones.service";

@Injectable({
    providedIn: "root",
})
export class ErrorInterceptorService implements HttpInterceptor {
    constructor(private _notificacionSrvc: NotificacionesService) {}
    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            //retry(1),

            catchError((error: HttpErrorResponse) => {
                //Excepcion cuando va a buscar el rut de una persona y no encuentra datos
                if (
                    error.status == 404 &&
                    request.method == "GET" &&
                    request.url.indexOf("/api/personas/")
                ) {
                    return throwError(`Error: 'La persona buscada no existe'`);
                }

                let errorMessage = "";
                if (error.error instanceof ErrorEvent) {
                    // client-side error
                    errorMessage = `Error: ${error.error.message}`;
                } else {
                    // server-side error
                    errorMessage = `Error Status: ${error.status}\nMessage: ${error.message}`;
                }
                //console.log(errorMessage);
                this._notificacionSrvc.mostrarNotificacion(
                    "A ocurrido un error, favor vuelva a intentarlo",
                    "error"
                );
                return throwError(errorMessage);
            })
        );
    }
}
